import { Link as WebUILink } from "@stenajs-webui/elements";
import type { FC } from "react";

import { Link } from "../../../common-ui/Link";
import { modalRouteCreators } from "../../../common/routes/AppRoutes";
import { useLinkModalProps } from "../../../common/routes/useLinkModalProps";
import { trackEvent } from "../../../common/tracking/trackerService";
import { useNotificationContext } from "../context/NotificationContext";

interface IntermodalLinkProps {
  bookingNo: number;
}

export const IntermodalLink: FC<IntermodalLinkProps> = ({ bookingNo }) => {
  const { trackerCategory, onRequestClose } = useNotificationContext();

  const intermodalDetailsLinkProps = useLinkModalProps(
    modalRouteCreators.intermodalDetailsEdit({ bookingNo }),
  );

  return (
    <Link
      {...intermodalDetailsLinkProps}
      onClick={() => {
        onRequestClose?.();
        trackEvent({
          category: trackerCategory,
          action: "Show intermodal details",
        });
      }}
      render={(props) => <WebUILink {...props}>{bookingNo}</WebUILink>}
    />
  );
};
